<script>
export default {
  name: 'CopyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 26,
    },
    color: {
      type: String,
      default: '#56AF79',
    },
  },
  computed: {
    // ID único por instância (this._uid é garantido único por componente Vue) —
    // o id fixo original colide quando o ícone renderiza mais de uma vez na página.
    maskId() {
      return `mask0_3664_86242_${this._uid}`
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon/Fill/copy">
      <mask
        :id="maskId"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="14"
        height="14"
      >
        <path
          id="Mask_2"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.75 9V9.75H4.25025C3.97425 9.75 3.75 9.52575 3.75 9.24975V4.25025C3.75 3.97425 3.97425 3.75 4.25025 3.75H9.24975C9.52575 3.75 9.75 3.97425 9.75 4.25025V6.75H9C7.7595 6.75 6.75 7.7595 6.75 9ZM13.5 6.75H11.25V4.25025C11.25 3.147 10.353 2.25 9.24975 2.25H4.25025C3.147 2.25 2.25 3.147 2.25 4.25025V9.24975C2.25 10.353 3.147 11.25 4.25025 11.25H6.75V13.5C6.75 14.7405 7.7595 15.75 9 15.75H13.5C14.7405 15.75 15.75 14.7405 15.75 13.5V9C15.75 7.7595 14.7405 6.75 13.5 6.75Z"
          fill="white"
        />
      </mask>
      <g :mask="`url(#${maskId})`">
        <g id="🎨 Color">
          <rect id="Base" width="18" height="18" :fill="color" />
        </g>
      </g>
    </g>
  </svg>
</template>
